import * as React from 'react'

interface Props {
    message?: {
        args: {
            gc: number
            gcc: number
        }
    }
}

export default class Gc extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p>There were trace triggering PHP garbage collection multiple time</p>

        if (message) {
            const { args } = message
            intro = (
                <p>
                    This trace triggered PHP garbage collection {args.gc} times and cleaned up {args.gcc} objects from memory.
                </p>
            )
        }

        return (
            <div>
                {intro}
                <p>
                    High number of garbage collection indicates excessive allocation and deallocation of memory, which can be very
                    inefficient and slow. If the number of cleaned up objects is small, even though the garbage collector ran multiple
                    times, then this means that objects are actually in use and the collection is inefficient.
                </p>

                <p>
                    Sometimes it is necessary to disable garbage collection in certain requests, because it is not collecting any objects.
                    You can do this by calling the function
                    <code>gc_disable();</code> in your code.
                </p>

                <ul>
                    <li>
                        PHP Documentation: <a href="http://php.net/gc_disable">gc_disable()</a>
                    </li>
                    <li>
                        Wikipedia:{' '}
                        <a href="https://en.wikipedia.org/wiki/Reference_counting" target="_blank" rel="noreferrer">
                            reference counting and garbage collection
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}
